import { Box, Heading } from "@chakra-ui/react"
import { Outlet } from "react-router-dom"
import { useEffect } from "react"
import LogRocket from 'logrocket'
import LeftMenu from "../LeftMenu"
import { useAuth } from "../../contexts/AuthContext"
import { useUserDetails } from "../../hooks/useAuthQueries"

const AppLayout: React.FC = () => {
  const { isAuthenticated, setUser } = useAuth()
  const { data: userDetails, isLoading } = useUserDetails()

  useEffect(() => {
    // Only initialize LogRocket in production
    if (process.env.NODE_ENV === 'production') {
      LogRocket.init('gr15ib/greenflip')
    }
  }, [])

  // Set user details in LogRocket when user data is loaded
  useEffect(() => {
    if (isAuthenticated && userDetails && !isLoading) {
      const userData = userDetails.data || userDetails
      // Only set user if we have valid user data with an ID
      if (userData && userData.id) {
        setUser({
          id: userData.id,
          email: userData.email || '',
          firstName: userData.firstName || '',
          lastName: userData.lastName || '',
          companyName: userData.companyName || '',
          companyNumber: userData.companyNumber || '',
        })
      }
    }
  }, [isAuthenticated, userDetails, isLoading, setUser])

  return (
    <Box bg="gray.100">
      <LeftMenu />
        {/* <Box pt="16px" pr="16px" mt={{ base: 16, sm: 16,md: 16, lg: 0 }}> */}
        <Box 
          ml={{ base: "0px", lg: "280px" }}
          minH="calc(100vh)"
          bg="white"
          display="flex"
          flexDirection="column"
          boxShadow="xl"
        > 
          {/* Main content area */}
           <Outlet />
         </Box>
       </Box>
    //  </Box>
  )
}

export default AppLayout
